import type { CardColumnId, ColumnTone, TaskColumnId } from '@voll-intelligence/domain';

export function cardColumnTone(id: CardColumnId): ColumnTone {
  switch (id) {
    case 'backlog':
      return 'gray';
    case 'in_progress':
      return 'brand';
    case 'resolved':
      return 'green';
    default: {
      const exhaustive: never = id;
      return exhaustive;
    }
  }
}

export function taskColumnTone(id: TaskColumnId): ColumnTone {
  switch (id) {
    case 'ai_handling':
      return 'ai';
    case 'awaiting_human':
      return 'amber';
    case 'human_handling':
      return 'brand';
    case 'resolved':
      return 'green';
    default: {
      const exhaustive: never = id;
      return exhaustive;
    }
  }
}
